/**
 * @generated SignedSource<<a51fd575e913586d4699bc04d1938c1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetLessonAgendaFilterBar_facility$data = {
  readonly lessonTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startEndTime: {
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonNoun_facility">;
  readonly " $fragmentType": "useGetLessonAgendaFilterBar_facility";
};
export type useGetLessonAgendaFilterBar_facility$key = {
  readonly " $data"?: useGetLessonAgendaFilterBar_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetLessonAgendaFilterBar_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetLessonAgendaFilterBar_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityLessonNoun_facility"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityStartEndTime",
      "kind": "LinkedField",
      "name": "startEndTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LessonTypeConnection",
      "kind": "LinkedField",
      "name": "lessonTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LessonType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "d32e21caba6932428939372a0e4959cf";

export default node;
